import type { CustomIconProps } from '../types';

const Like = ({ width, height }: CustomIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '16'}
        height={height ?? '14'}
        viewBox="0 0 16 14"
        fill="none"
    >
        <path
            d="M8 14L7.71765 13.7643C1.64706 8.81482 0 7.07071 0 4.24242C0 1.88552 1.88235 0 4.23529 0C6.16471 0 7.24706 1.08418 8 1.93266C8.75294 1.08418 9.83529 0 11.7647 0C14.1176 0 16 1.88552 16 4.24242C16 7.07071 14.3529 8.81482 8.28235 13.7643L8 14ZM4.23529 0.942761C2.4 0.942761 0.941176 2.40404 0.941176 4.24242C0.941176 6.64646 2.44706 8.24916 8 12.7744C13.5529 8.24916 15.0588 6.64646 15.0588 4.24242C15.0588 2.40404 13.6 0.942761 11.7647 0.942761C10.1176 0.942761 9.22353 1.93266 8.51765 2.73401L8 3.3468L7.48235 2.73401C6.77647 1.93266 5.88235 0.942761 4.23529 0.942761Z"
            fill="#414042"
        />
    </svg>
);

export default Like;
